export const Loader = {
  v: '5.4.2',
  fr: 59.9400024414063,
  ip: 0,
  op: 138.000005620855,
  w: 300,
  h: 300,
  nm: 'Pre-comp 8',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: 'Null 1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 0,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [151.06, 150.646, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [49, 3.398, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [25, 25, 100],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 195.000007942513,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'pillow-fill Outlines 3',
      parent: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0.898],
                y: [0.997],
              },
              o: {
                x: [0.259],
                y: [0.037],
              },
              n: ['0p898_0p997_0p259_0p037'],
              t: 0,
              s: [14],
              e: [200],
            },
            {
              i: {
                x: [0.853],
                y: [0.93],
              },
              o: {
                x: [0],
                y: [0],
              },
              n: ['0p853_0p93_0_0'],
              t: 15,
              s: [200],
              e: [282],
            },
            {
              i: {
                x: [0.475],
                y: [0.336],
              },
              o: {
                x: [0.144],
                y: [0.009],
              },
              n: ['0p475_0p336_0p144_0p009'],
              t: 48,
              s: [282],
              e: [678.804],
            },
            {
              i: {
                x: [0.891],
                y: [0.955],
              },
              o: {
                x: [0.549],
                y: [0.699],
              },
              n: ['0p891_0p955_0p549_0p699'],
              t: 70,
              s: [678.804],
              e: [822.553],
            },
            {
              i: {
                x: [0.896],
                y: [0.781],
              },
              o: {
                x: [0.155],
                y: [0.425],
              },
              n: ['0p896_0p781_0p155_0p425'],
              t: 78,
              s: [822.553],
              e: [931],
            },
            {
              i: {
                x: [1],
                y: [1],
              },
              o: {
                x: [0.609],
                y: [0.614],
              },
              n: ['1_1_0p609_0p614'],
              t: 116,
              s: [931],
              e: [944],
            },
            {
              i: {
                x: [0.833],
                y: [1],
              },
              o: {
                x: [0.096],
                y: [0.037],
              },
              n: ['0p833_1_0p096_0p037'],
              t: 118,
              s: [944],
              e: [1354],
            },
            {
              t: 138.000005620855,
            },
          ],
          ix: 10,
        },
        p: {
          a: 0,
          k: [49, 3.398, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [37, 29, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              n: ['0p667_1_0p333_0', '0p667_1_0p333_0', '0p667_1_0p333_0'],
              t: -0.335,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              i: {
                x: [0.001, 0.001, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.122, 0.122, 0.333],
                y: [0, 0, 0],
              },
              n: ['0p001_1_0p122_0', '0p001_1_0p122_0', '0p667_1_0p333_0'],
              t: 16,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              i: {
                x: [0.281, 0.281, 0.667],
                y: [2.559, 2.559, 1],
              },
              o: {
                x: [0, 0, 0.333],
                y: [0, 0, 0],
              },
              n: ['0p281_2p559_0_0', '0p281_2p559_0_0', '0p667_1_0p333_0'],
              t: 48,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              i: {
                x: [0.833, 0.833, 0.833],
                y: [1, 1, 1],
              },
              o: {
                x: [0.167, 0.167, 0.167],
                y: [0, 0, 0],
              },
              n: ['0p833_1_0p167_0', '0p833_1_0p167_0', '0p833_1_0p167_0'],
              t: 70.483,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              i: {
                x: [0.746, 0.746, 0.833],
                y: [13.595, 13.595, 1],
              },
              o: {
                x: [0.317, 0.317, 0.167],
                y: [-2.78, -2.78, 0],
              },
              n: ['0p746_13p595_0p317_-2p78', '0p746_13p595_0p317_-2p78', '0p833_1_0p167_0'],
              t: 84,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              i: {
                x: [0.833, 0.833, 0.833],
                y: [1, 1, 1],
              },
              o: {
                x: [0.167, 0.167, 0.167],
                y: [0, 0, 0],
              },
              n: ['0p833_1_0p167_0', '0p833_1_0p167_0', '0p833_1_0p167_0'],
              t: 107,
              s: [400, 400, 100],
              e: [400, 400, 100],
            },
            {
              t: 138.000005620855,
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ef: [
        {
          ty: 21,
          nm: 'Fill',
          np: 9,
          mn: 'ADBE Fill',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 10,
              nm: 'Fill Mask',
              mn: 'ADBE Fill-0001',
              ix: 1,
              v: {
                a: 0,
                k: 0,
                ix: 1,
              },
            },
            {
              ty: 7,
              nm: 'All Masks',
              mn: 'ADBE Fill-0007',
              ix: 2,
              v: {
                a: 0,
                k: 0,
                ix: 2,
              },
            },
            {
              ty: 2,
              nm: 'Color',
              mn: 'ADBE Fill-0002',
              ix: 3,
              v: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.667],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p667_1_0p333_0'],
                    t: 0,
                    s: [0.960784316063, 0.560784339905, 0.105882354081, 1],
                    e: [1, 0.582076489925, 0.107450902462, 1],
                  },
                  {
                    i: {
                      x: [0.667],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p667_1_0p333_0'],
                    t: 16,
                    s: [1, 0.582076489925, 0.107450902462, 1],
                    e: [0.960784316063, 0.560661375523, 0.106251455843, 1],
                  },
                  {
                    i: {
                      x: [0.667],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p667_1_0p333_0'],
                    t: 55,
                    s: [0.960784316063, 0.560661375523, 0.106251455843, 1],
                    e: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                  },
                  {
                    i: {
                      x: [0.667],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p667_1_0p333_0'],
                    t: 70,
                    s: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                    e: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                  },
                  {
                    i: {
                      x: [0.833],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p833_1_0p333_0'],
                    t: 84,
                    s: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                    e: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                  },
                  {
                    i: {
                      x: [0.667],
                      y: [1],
                    },
                    o: {
                      x: [0.333],
                      y: [0],
                    },
                    n: ['0p667_1_0p333_0'],
                    t: 129,
                    s: [0.533333361149, 0.282352954149, 0.945098042488, 1],
                    e: [0.960784316063, 0.560784339905, 0.105882354081, 1],
                  },
                  {
                    t: 138.000005620855,
                  },
                ],
                ix: 3,
              },
            },
            {
              ty: 7,
              nm: 'Invert',
              mn: 'ADBE Fill-0006',
              ix: 4,
              v: {
                a: 0,
                k: 0,
                ix: 4,
              },
            },
            {
              ty: 0,
              nm: 'Horizontal Feather',
              mn: 'ADBE Fill-0003',
              ix: 5,
              v: {
                a: 0,
                k: 0,
                ix: 5,
              },
            },
            {
              ty: 0,
              nm: 'Vertical Feather',
              mn: 'ADBE Fill-0004',
              ix: 6,
              v: {
                a: 0,
                k: 0,
                ix: 6,
              },
            },
            {
              ty: 0,
              nm: 'Opacity',
              mn: 'ADBE Fill-0005',
              ix: 7,
              v: {
                a: 0,
                k: 1,
                ix: 7,
              },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.312,
                      y: 0.929,
                    },
                    o: {
                      x: 0,
                      y: 0,
                    },
                    n: '0p312_0p929_0_0',
                    t: 0,
                    s: [
                      {
                        i: [
                          [-0.008, 0.651],
                          [0.234, 0.749],
                          [0.254, 0.681],
                          [0.457, 0.684],
                          [0.442, 0.655],
                          [0.64, 0.537],
                          [0.743, 0.623],
                          [1.086, 0.604],
                          [0.69, 0.301],
                          [0.868, 0.214],
                          [0.742, 0.122],
                          [0.73, -0.108],
                          [0.614, -0.17],
                          [0.545, -0.191],
                          [0.421, -0.222],
                          [0.609, -0.354],
                          [0.408, -0.33],
                          [0.437, -0.522],
                          [0.373, -0.724],
                          [0.201, -0.699],
                          [0.207, -0.72],
                          [0.075, -1.008],
                          [-0.055, -1.134],
                          [-0.167, -0.73],
                          [-0.206, -0.737],
                          [-0.527, -1.239],
                          [-0.682, -1.157],
                          [-0.744, -0.954],
                          [-0.769, -0.83],
                          [-0.729, -0.52],
                          [-1, -0.67],
                          [-1.122, -0.478],
                          [-0.82, -0.238],
                          [-0.475, -0.043],
                          [-0.521, 0.125],
                          [-0.941, 0.583],
                          [-0.485, 0.389],
                          [-0.481, 0.624],
                          [-0.23, 0.404],
                          [-0.205, 0.473],
                          [-0.089, 0.606],
                        ],
                        o: [
                          [0.008, -0.651],
                          [-0.234, -0.749],
                          [-0.254, -0.681],
                          [-0.457, -0.684],
                          [-0.442, -0.655],
                          [-0.64, -0.537],
                          [-0.743, -0.623],
                          [-1.086, -0.604],
                          [-0.69, -0.302],
                          [-0.868, -0.214],
                          [-0.742, -0.122],
                          [-0.73, 0.108],
                          [-0.614, 0.17],
                          [-0.545, 0.191],
                          [-0.421, 0.222],
                          [-0.609, 0.354],
                          [-0.408, 0.33],
                          [-0.437, 0.522],
                          [-0.373, 0.724],
                          [-0.201, 0.699],
                          [-0.207, 0.72],
                          [-0.075, 1.008],
                          [0.055, 1.134],
                          [0.167, 0.73],
                          [0.207, 0.737],
                          [0.525, 1.236],
                          [0.615, 1.042],
                          [0.696, 0.892],
                          [0.65, 0.701],
                          [0.729, 0.52],
                          [1.403, 0.94],
                          [1.122, 0.478],
                          [0.82, 0.238],
                          [0.475, 0.043],
                          [0.521, -0.125],
                          [0.941, -0.583],
                          [0.485, -0.389],
                          [0.481, -0.624],
                          [0.23, -0.404],
                          [0.205, -0.473],
                          [0.089, -0.606],
                        ],
                        v: [
                          [21.064, -0.892],
                          [20.746, -4.293],
                          [19.822, -7.447],
                          [18.61, -10.518],
                          [16.656, -13.26],
                          [14.849, -15.522],
                          [12.485, -17.553],
                          [9.765, -19.13],
                          [7.083, -20.109],
                          [4.596, -20.818],
                          [1.778, -21.117],
                          [-1.539, -21.233],
                          [-4.808, -20.598],
                          [-7.899, -19.428],
                          [-10.16, -18.231],
                          [-12.558, -16.512],
                          [-14.071, -15.455],
                          [-15.643, -13.642],
                          [-17.217, -11.587],
                          [-18.587, -8.853],
                          [-19.62, -5.816],
                          [-20.272, -2.506],
                          [-20.273, 0.183],
                          [-20.039, 3.294],
                          [-19.4, 5.596],
                          [-18.778, 7.485],
                          [-17.602, 9.434],
                          [-16.412, 11.268],
                          [-14.553, 13.496],
                          [-11.753, 16.083],
                          [-8.758, 17.736],
                          [-5.919, 18.929],
                          [-3.513, 19.607],
                          [-0.622, 19.902],
                          [4.054, 19.77],
                          [9.046, 18.115],
                          [13.265, 15.507],
                          [16.455, 12.555],
                          [18.616, 9.175],
                          [19.961, 6.41],
                          [20.755, 2.961],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [-1.567, 0.626],
                          [2.045, 1.479],
                          [1.458, 0.686],
                          [1.661, 0.626],
                          [0.319, 0.977],
                          [0.22, 1.496],
                          [0.298, 1.933],
                          [0.38, 1.804],
                          [1.88, -1.196],
                          [1.143, -1.266],
                          [1.85, -1.959],
                          [1.942, -1.321],
                          [1.914, 0.633],
                          [1.496, 0.664],
                          [0.923, 0.398],
                          [1.208, -0.056],
                          [0.853, -1.038],
                          [-0.485, -1.177],
                          [-0.59, -1.961],
                          [-0.567, -1.889],
                          [-0.321, -0.894],
                          [0.498, -0.954],
                          [0.584, -1.147],
                          [0.85, -1.861],
                          [0.525, -1.017],
                          [0.287, -0.606],
                          [-0.379, -0.965],
                          [-1.873, -0.024],
                          [-1.672, 0.073],
                          [-1.17, 0.139],
                          [-1.003, -0.02],
                          [-1.308, 0.11],
                          [-0.703, -0.781],
                          [-1.424, -1.656],
                          [-1.083, -1.096],
                          [-1.173, -1.43],
                          [-0.492, 1.323],
                          [-0.946, 2.641],
                          [-0.244, 1.474],
                          [-1.643, 0.826],
                          [-2.205, 0.993],
                        ],
                        o: [
                          [1.567, -0.626],
                          [-2.045, -1.479],
                          [-1.458, -0.686],
                          [-1.661, -0.626],
                          [-0.319, -0.977],
                          [-0.22, -1.496],
                          [-0.298, -1.933],
                          [-0.38, -1.804],
                          [-1.88, 1.196],
                          [-1.144, 1.266],
                          [-1.85, 1.959],
                          [-1.942, 1.321],
                          [-1.914, -0.633],
                          [-1.496, -0.664],
                          [-0.923, -0.398],
                          [-1.208, 0.056],
                          [-0.853, 1.038],
                          [0.485, 1.177],
                          [0.59, 1.961],
                          [0.567, 1.889],
                          [0.321, 0.894],
                          [-0.498, 0.954],
                          [-0.584, 1.147],
                          [-0.85, 1.861],
                          [-0.525, 1.017],
                          [-0.287, 0.606],
                          [0.379, 0.965],
                          [1.873, 0.024],
                          [1.672, -0.073],
                          [1.17, -0.139],
                          [1.003, 0.02],
                          [1.308, -0.11],
                          [0.703, 0.781],
                          [1.424, 1.656],
                          [1.083, 1.096],
                          [1.173, 1.43],
                          [0.492, -1.323],
                          [0.946, -2.641],
                          [0.244, -1.474],
                          [1.643, -0.826],
                          [2.205, -0.993],
                        ],
                        v: [
                          [42.432, 4.113],
                          [43.099, -1.634],
                          [34.951, -7.558],
                          [24.599, -15.108],
                          [22.851, -18.243],
                          [21.962, -24.752],
                          [21.088, -32.346],
                          [20.075, -39.917],
                          [15.24, -41.637],
                          [9.902, -37.235],
                          [3.167, -31.16],
                          [-0.478, -27.762],
                          [-5.214, -26.607],
                          [-12.035, -28.573],
                          [-18.334, -30.459],
                          [-25.555, -32.195],
                          [-28.826, -30.494],
                          [-28.559, -25.884],
                          [-26.372, -19.04],
                          [-23.776, -11.727],
                          [-22.099, -5.586],
                          [-22.495, -2.35],
                          [-25.305, 2.182],
                          [-28.418, 7.552],
                          [-30.697, 11.794],
                          [-32.739, 15.498],
                          [-32.712, 18.897],
                          [-29.041, 21.037],
                          [-24.774, 21.027],
                          [-19.262, 20.873],
                          [-13.908, 20.66],
                          [-7.942, 20.625],
                          [-5.114, 21.87],
                          [-2.27, 25.01],
                          [5.473, 34.053],
                          [9.285, 38.608],
                          [14.735, 37.695],
                          [16.412, 32.177],
                          [21.02, 15.882],
                          [23.302, 11.896],
                          [34.052, 7.585],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.312,
                      y: 0.929,
                    },
                    o: {
                      x: 0.11,
                      y: 0.011,
                    },
                    n: '0p312_0p929_0p11_0p011',
                    t: 16,
                    s: [
                      {
                        i: [
                          [-1.567, 0.626],
                          [2.045, 1.479],
                          [1.458, 0.686],
                          [1.661, 0.626],
                          [0.319, 0.977],
                          [0.22, 1.496],
                          [0.298, 1.933],
                          [0.38, 1.804],
                          [1.88, -1.196],
                          [1.143, -1.266],
                          [1.85, -1.959],
                          [1.942, -1.321],
                          [1.914, 0.633],
                          [1.496, 0.664],
                          [0.923, 0.398],
                          [1.208, -0.056],
                          [0.853, -1.038],
                          [-0.485, -1.177],
                          [-0.59, -1.961],
                          [-0.567, -1.889],
                          [-0.321, -0.894],
                          [0.498, -0.954],
                          [0.584, -1.147],
                          [0.85, -1.861],
                          [0.525, -1.017],
                          [0.287, -0.606],
                          [-0.379, -0.965],
                          [-1.873, -0.024],
                          [-1.672, 0.073],
                          [-1.17, 0.139],
                          [-1.003, -0.02],
                          [-1.308, 0.11],
                          [-0.703, -0.781],
                          [-1.424, -1.656],
                          [-1.083, -1.096],
                          [-1.173, -1.43],
                          [-0.492, 1.323],
                          [-0.946, 2.641],
                          [-0.244, 1.474],
                          [-1.643, 0.826],
                          [-2.205, 0.993],
                        ],
                        o: [
                          [1.567, -0.626],
                          [-2.045, -1.479],
                          [-1.458, -0.686],
                          [-1.661, -0.626],
                          [-0.319, -0.977],
                          [-0.22, -1.496],
                          [-0.298, -1.933],
                          [-0.38, -1.804],
                          [-1.88, 1.196],
                          [-1.144, 1.266],
                          [-1.85, 1.959],
                          [-1.942, 1.321],
                          [-1.914, -0.633],
                          [-1.496, -0.664],
                          [-0.923, -0.398],
                          [-1.208, 0.056],
                          [-0.853, 1.038],
                          [0.485, 1.177],
                          [0.59, 1.961],
                          [0.567, 1.889],
                          [0.321, 0.894],
                          [-0.498, 0.954],
                          [-0.584, 1.147],
                          [-0.85, 1.861],
                          [-0.525, 1.017],
                          [-0.287, 0.606],
                          [0.379, 0.965],
                          [1.873, 0.024],
                          [1.672, -0.073],
                          [1.17, -0.139],
                          [1.003, 0.02],
                          [1.308, -0.11],
                          [0.703, 0.781],
                          [1.424, 1.656],
                          [1.083, 1.096],
                          [1.173, 1.43],
                          [0.492, -1.323],
                          [0.946, -2.641],
                          [0.244, -1.474],
                          [1.643, -0.826],
                          [2.205, -0.993],
                        ],
                        v: [
                          [42.432, 4.113],
                          [43.099, -1.634],
                          [34.951, -7.558],
                          [24.599, -15.108],
                          [22.851, -18.243],
                          [21.962, -24.752],
                          [21.088, -32.346],
                          [20.075, -39.917],
                          [15.24, -41.637],
                          [9.902, -37.235],
                          [3.167, -31.16],
                          [-0.478, -27.762],
                          [-5.214, -26.607],
                          [-12.035, -28.573],
                          [-18.334, -30.459],
                          [-25.555, -32.195],
                          [-28.826, -30.494],
                          [-28.559, -25.884],
                          [-26.372, -19.04],
                          [-23.776, -11.727],
                          [-22.099, -5.586],
                          [-22.495, -2.35],
                          [-25.305, 2.182],
                          [-28.418, 7.552],
                          [-30.697, 11.794],
                          [-32.739, 15.498],
                          [-32.712, 18.897],
                          [-29.041, 21.037],
                          [-24.774, 21.027],
                          [-19.262, 20.873],
                          [-13.908, 20.66],
                          [-7.942, 20.625],
                          [-5.114, 21.87],
                          [-2.27, 25.01],
                          [5.473, 34.053],
                          [9.285, 38.608],
                          [14.735, 37.695],
                          [16.412, 32.177],
                          [21.02, 15.882],
                          [23.302, 11.896],
                          [34.052, 7.585],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [-1.567, 0.626],
                          [2.045, 1.479],
                          [1.458, 0.686],
                          [1.661, 0.626],
                          [0.319, 0.977],
                          [0.22, 1.496],
                          [0.298, 1.933],
                          [0.38, 1.804],
                          [1.88, -1.196],
                          [1.143, -1.266],
                          [1.85, -1.959],
                          [1.942, -1.321],
                          [1.914, 0.633],
                          [1.496, 0.664],
                          [0.923, 0.398],
                          [1.208, -0.056],
                          [0.853, -1.038],
                          [-0.485, -1.177],
                          [-0.59, -1.961],
                          [-0.567, -1.889],
                          [-0.321, -0.894],
                          [0.498, -0.954],
                          [0.584, -1.147],
                          [0.85, -1.861],
                          [0.525, -1.017],
                          [0.287, -0.606],
                          [-0.379, -0.965],
                          [-1.873, -0.024],
                          [-1.672, 0.073],
                          [-1.17, 0.139],
                          [-1.003, -0.02],
                          [-1.308, 0.11],
                          [-0.703, -0.781],
                          [-1.424, -1.656],
                          [-1.083, -1.096],
                          [-1.173, -1.43],
                          [-0.492, 1.323],
                          [-0.946, 2.641],
                          [-0.244, 1.474],
                          [-1.643, 0.826],
                          [-2.205, 0.993],
                        ],
                        o: [
                          [1.567, -0.626],
                          [-2.045, -1.479],
                          [-1.458, -0.686],
                          [-1.661, -0.626],
                          [-0.319, -0.977],
                          [-0.22, -1.496],
                          [-0.298, -1.933],
                          [-0.38, -1.804],
                          [-1.88, 1.196],
                          [-1.144, 1.266],
                          [-1.85, 1.959],
                          [-1.942, 1.321],
                          [-1.914, -0.633],
                          [-1.496, -0.664],
                          [-0.923, -0.398],
                          [-1.208, 0.056],
                          [-0.853, 1.038],
                          [0.485, 1.177],
                          [0.59, 1.961],
                          [0.567, 1.889],
                          [0.321, 0.894],
                          [-0.498, 0.954],
                          [-0.584, 1.147],
                          [-0.85, 1.861],
                          [-0.525, 1.017],
                          [-0.287, 0.606],
                          [0.379, 0.965],
                          [1.873, 0.024],
                          [1.672, -0.073],
                          [1.17, -0.139],
                          [1.003, 0.02],
                          [1.308, -0.11],
                          [0.703, 0.781],
                          [1.424, 1.656],
                          [1.083, 1.096],
                          [1.173, 1.43],
                          [0.492, -1.323],
                          [0.946, -2.641],
                          [0.244, -1.474],
                          [1.643, -0.826],
                          [2.205, -0.993],
                        ],
                        v: [
                          [42.432, 4.113],
                          [43.099, -1.634],
                          [34.951, -7.558],
                          [24.599, -15.108],
                          [22.851, -18.243],
                          [21.962, -24.752],
                          [21.088, -32.346],
                          [20.075, -39.917],
                          [15.24, -41.637],
                          [9.902, -37.235],
                          [3.167, -31.16],
                          [-0.478, -27.762],
                          [-5.214, -26.607],
                          [-12.035, -28.573],
                          [-18.334, -30.459],
                          [-25.555, -32.195],
                          [-28.826, -30.494],
                          [-28.559, -25.884],
                          [-26.372, -19.04],
                          [-23.776, -11.727],
                          [-22.099, -5.586],
                          [-22.495, -2.35],
                          [-25.305, 2.182],
                          [-28.418, 7.552],
                          [-30.697, 11.794],
                          [-32.739, 15.498],
                          [-32.712, 18.897],
                          [-29.041, 21.037],
                          [-24.774, 21.027],
                          [-19.262, 20.873],
                          [-13.908, 20.66],
                          [-7.942, 20.625],
                          [-5.114, 21.87],
                          [-2.27, 25.01],
                          [5.473, 34.053],
                          [9.285, 38.608],
                          [14.735, 37.695],
                          [16.412, 32.177],
                          [21.02, 15.882],
                          [23.302, 11.896],
                          [34.052, 7.585],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 1,
                    },
                    o: {
                      x: 0.11,
                      y: 0.011,
                    },
                    n: '0p833_1_0p11_0p011',
                    t: 48,
                    s: [
                      {
                        i: [
                          [-1.567, 0.626],
                          [2.045, 1.479],
                          [1.458, 0.686],
                          [1.661, 0.626],
                          [0.319, 0.977],
                          [0.22, 1.496],
                          [0.298, 1.933],
                          [0.38, 1.804],
                          [1.88, -1.196],
                          [1.143, -1.266],
                          [1.85, -1.959],
                          [1.942, -1.321],
                          [1.914, 0.633],
                          [1.496, 0.664],
                          [0.923, 0.398],
                          [1.208, -0.056],
                          [0.853, -1.038],
                          [-0.485, -1.177],
                          [-0.59, -1.961],
                          [-0.567, -1.889],
                          [-0.321, -0.894],
                          [0.498, -0.954],
                          [0.584, -1.147],
                          [0.85, -1.861],
                          [0.525, -1.017],
                          [0.287, -0.606],
                          [-0.379, -0.965],
                          [-1.873, -0.024],
                          [-1.672, 0.073],
                          [-1.17, 0.139],
                          [-1.003, -0.02],
                          [-1.308, 0.11],
                          [-0.703, -0.781],
                          [-1.424, -1.656],
                          [-1.083, -1.096],
                          [-1.173, -1.43],
                          [-0.492, 1.323],
                          [-0.946, 2.641],
                          [-0.244, 1.474],
                          [-1.643, 0.826],
                          [-2.205, 0.993],
                        ],
                        o: [
                          [1.567, -0.626],
                          [-2.045, -1.479],
                          [-1.458, -0.686],
                          [-1.661, -0.626],
                          [-0.319, -0.977],
                          [-0.22, -1.496],
                          [-0.298, -1.933],
                          [-0.38, -1.804],
                          [-1.88, 1.196],
                          [-1.144, 1.266],
                          [-1.85, 1.959],
                          [-1.942, 1.321],
                          [-1.914, -0.633],
                          [-1.496, -0.664],
                          [-0.923, -0.398],
                          [-1.208, 0.056],
                          [-0.853, 1.038],
                          [0.485, 1.177],
                          [0.59, 1.961],
                          [0.567, 1.889],
                          [0.321, 0.894],
                          [-0.498, 0.954],
                          [-0.584, 1.147],
                          [-0.85, 1.861],
                          [-0.525, 1.017],
                          [-0.287, 0.606],
                          [0.379, 0.965],
                          [1.873, 0.024],
                          [1.672, -0.073],
                          [1.17, -0.139],
                          [1.003, 0.02],
                          [1.308, -0.11],
                          [0.703, 0.781],
                          [1.424, 1.656],
                          [1.083, 1.096],
                          [1.173, 1.43],
                          [0.492, -1.323],
                          [0.946, -2.641],
                          [0.244, -1.474],
                          [1.643, -0.826],
                          [2.205, -0.993],
                        ],
                        v: [
                          [42.432, 4.113],
                          [43.099, -1.634],
                          [34.951, -7.558],
                          [24.599, -15.108],
                          [22.851, -18.243],
                          [21.962, -24.752],
                          [21.088, -32.346],
                          [20.075, -39.917],
                          [15.24, -41.637],
                          [9.902, -37.235],
                          [3.167, -31.16],
                          [-0.478, -27.762],
                          [-5.214, -26.607],
                          [-12.035, -28.573],
                          [-18.334, -30.459],
                          [-25.555, -32.195],
                          [-28.826, -30.494],
                          [-28.559, -25.884],
                          [-26.372, -19.04],
                          [-23.776, -11.727],
                          [-22.099, -5.586],
                          [-22.495, -2.35],
                          [-25.305, 2.182],
                          [-28.418, 7.552],
                          [-30.697, 11.794],
                          [-32.739, 15.498],
                          [-32.712, 18.897],
                          [-29.041, 21.037],
                          [-24.774, 21.027],
                          [-19.262, 20.873],
                          [-13.908, 20.66],
                          [-7.942, 20.625],
                          [-5.114, 21.87],
                          [-2.27, 25.01],
                          [5.473, 34.053],
                          [9.285, 38.608],
                          [14.735, 37.695],
                          [16.412, 32.177],
                          [21.02, 15.882],
                          [23.302, 11.896],
                          [34.052, 7.585],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [-0.164, 0.666],
                          [-0.132, 1.029],
                          [0.026, 1.251],
                          [0.074, 0.581],
                          [0.358, 1.092],
                          [0.248, 0.704],
                          [1.121, 1.104],
                          [1.435, 1.032],
                          [1.441, 0.679],
                          [1.445, 0.432],
                          [1.899, 0.293],
                          [0.833, -0.142],
                          [0.413, -0.122],
                          [0.426, -0.177],
                          [0.495, -0.159],
                          [0.384, -0.274],
                          [0.833, -0.788],
                          [0.699, -0.878],
                          [0.472, -0.73],
                          [0.589, -1.356],
                          [0.05, -0.798],
                          [-0.283, -1.198],
                          [-0.322, -0.62],
                          [-0.235, -0.497],
                          [-0.266, -0.328],
                          [-0.189, -0.124],
                          [-0.441, -0.322],
                          [-0.623, -0.516],
                          [-0.443, -0.257],
                          [-0.54, -0.19],
                          [-0.903, -0.308],
                          [-0.946, -0.133],
                          [-0.69, -0.062],
                          [-1.11, 0.202],
                          [-1.04, 0.307],
                          [-1, 0.486],
                          [-0.799, 0.601],
                          [-0.618, 0.391],
                          [-0.589, 0.601],
                          [-0.632, 0.836],
                          [-0.481, 0.921],
                        ],
                        o: [
                          [0.164, -0.666],
                          [0.132, -1.029],
                          [-0.026, -1.251],
                          [-0.074, -0.581],
                          [-0.475, -1.449],
                          [-0.758, -1.379],
                          [-1.259, -1.24],
                          [-1.294, -0.93],
                          [-1.364, -0.643],
                          [-1.841, -0.55],
                          [-1.97, -0.304],
                          [-0.833, 0.142],
                          [-0.413, 0.122],
                          [-0.426, 0.177],
                          [-0.495, 0.159],
                          [-0.384, 0.274],
                          [-0.815, 0.772],
                          [-0.782, 0.984],
                          [-0.788, 1.251],
                          [-0.695, 1.601],
                          [-0.05, 0.798],
                          [0.283, 1.198],
                          [0.322, 0.62],
                          [0.235, 0.497],
                          [0.266, 0.328],
                          [0.189, 0.124],
                          [0.441, 0.322],
                          [0.623, 0.516],
                          [0.443, 0.257],
                          [0.54, 0.19],
                          [0.903, 0.308],
                          [0.946, 0.133],
                          [0.69, 0.062],
                          [1.11, -0.202],
                          [1.04, -0.307],
                          [1, -0.486],
                          [0.799, -0.601],
                          [0.618, -0.391],
                          [0.589, -0.601],
                          [0.632, -0.836],
                          [0.481, -0.921],
                        ],
                        v: [
                          [19.384, 6.425],
                          [20.146, 3.209],
                          [20.23, 0.031],
                          [20.166, -2.632],
                          [19.671, -5.178],
                          [17.996, -9.035],
                          [16.202, -11.263],
                          [14.171, -13.697],
                          [11.154, -15.906],
                          [6.902, -17.733],
                          [3.227, -18.595],
                          [-0.842, -18.885],
                          [-3.578, -18.222],
                          [-5.861, -17.511],
                          [-7.6, -16.75],
                          [-9.464, -15.874],
                          [-10.957, -14.727],
                          [-13.237, -12.842],
                          [-15.17, -10.616],
                          [-17.149, -7.059],
                          [-18.529, -1.567],
                          [-18.531, 4.05],
                          [-17.118, 8.224],
                          [-15.915, 10.479],
                          [-14.581, 12.587],
                          [-13.347, 14.063],
                          [-11.933, 15.478],
                          [-10.543, 16.557],
                          [-8.363, 17.986],
                          [-6.277, 18.865],
                          [-4.35, 19.538],
                          [-2.001, 19.981],
                          [0.756, 20.264],
                          [3.465, 20.161],
                          [5.582, 19.693],
                          [7.582, 19.028],
                          [10.134, 17.674],
                          [12.532, 16.219],
                          [14.243, 14.909],
                          [16.655, 12.164],
                          [18.377, 9.399],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.667,
                      y: 1,
                    },
                    o: {
                      x: 0.167,
                      y: 0,
                    },
                    n: '0p667_1_0p167_0',
                    t: 70.483,
                    s: [
                      {
                        i: [
                          [-0.164, 0.666],
                          [-0.132, 1.029],
                          [0.026, 1.251],
                          [0.074, 0.581],
                          [0.358, 1.092],
                          [0.248, 0.704],
                          [1.121, 1.104],
                          [1.435, 1.032],
                          [1.441, 0.679],
                          [1.445, 0.432],
                          [1.899, 0.293],
                          [0.833, -0.142],
                          [0.413, -0.122],
                          [0.426, -0.177],
                          [0.495, -0.159],
                          [0.384, -0.274],
                          [0.833, -0.788],
                          [0.699, -0.878],
                          [0.472, -0.73],
                          [0.589, -1.356],
                          [0.05, -0.798],
                          [-0.283, -1.198],
                          [-0.322, -0.62],
                          [-0.235, -0.497],
                          [-0.266, -0.328],
                          [-0.189, -0.124],
                          [-0.441, -0.322],
                          [-0.623, -0.516],
                          [-0.443, -0.257],
                          [-0.54, -0.19],
                          [-0.903, -0.308],
                          [-0.946, -0.133],
                          [-0.69, -0.062],
                          [-1.11, 0.202],
                          [-1.04, 0.307],
                          [-1, 0.486],
                          [-0.799, 0.601],
                          [-0.618, 0.391],
                          [-0.589, 0.601],
                          [-0.632, 0.836],
                          [-0.481, 0.921],
                        ],
                        o: [
                          [0.164, -0.666],
                          [0.132, -1.029],
                          [-0.026, -1.251],
                          [-0.074, -0.581],
                          [-0.475, -1.449],
                          [-0.758, -1.379],
                          [-1.259, -1.24],
                          [-1.294, -0.93],
                          [-1.364, -0.643],
                          [-1.841, -0.55],
                          [-1.97, -0.304],
                          [-0.833, 0.142],
                          [-0.413, 0.122],
                          [-0.426, 0.177],
                          [-0.495, 0.159],
                          [-0.384, 0.274],
                          [-0.815, 0.772],
                          [-0.782, 0.984],
                          [-0.788, 1.251],
                          [-0.695, 1.601],
                          [-0.05, 0.798],
                          [0.283, 1.198],
                          [0.322, 0.62],
                          [0.235, 0.497],
                          [0.266, 0.328],
                          [0.189, 0.124],
                          [0.441, 0.322],
                          [0.623, 0.516],
                          [0.443, 0.257],
                          [0.54, 0.19],
                          [0.903, 0.308],
                          [0.946, 0.133],
                          [0.69, 0.062],
                          [1.11, -0.202],
                          [1.04, -0.307],
                          [1, -0.486],
                          [0.799, -0.601],
                          [0.618, -0.391],
                          [0.589, -0.601],
                          [0.632, -0.836],
                          [0.481, -0.921],
                        ],
                        v: [
                          [19.384, 6.425],
                          [20.146, 3.209],
                          [20.23, 0.031],
                          [20.166, -2.632],
                          [19.671, -5.178],
                          [17.996, -9.035],
                          [16.202, -11.263],
                          [14.171, -13.697],
                          [11.154, -15.906],
                          [6.902, -17.733],
                          [3.227, -18.595],
                          [-0.842, -18.885],
                          [-3.578, -18.222],
                          [-5.861, -17.511],
                          [-7.6, -16.75],
                          [-9.464, -15.874],
                          [-10.957, -14.727],
                          [-13.237, -12.842],
                          [-15.17, -10.616],
                          [-17.149, -7.059],
                          [-18.529, -1.567],
                          [-18.531, 4.05],
                          [-17.118, 8.224],
                          [-15.915, 10.479],
                          [-14.581, 12.587],
                          [-13.347, 14.063],
                          [-11.933, 15.478],
                          [-10.543, 16.557],
                          [-8.363, 17.986],
                          [-6.277, 18.865],
                          [-4.35, 19.538],
                          [-2.001, 19.981],
                          [0.756, 20.264],
                          [3.465, 20.161],
                          [5.582, 19.693],
                          [7.582, 19.028],
                          [10.134, 17.674],
                          [12.532, 16.219],
                          [14.243, 14.909],
                          [16.655, 12.164],
                          [18.377, 9.399],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [0, 0],
                          [-1.326, 4.188],
                          [0.1, 3.8],
                          [0.8, 3.7],
                          [-0.7, 2.9],
                          [0, 0],
                          [0, 0.5],
                          [2.2, 0.1],
                          [0, 0],
                          [0.7, -0.3],
                          [0, 0],
                          [3.7, 0.8],
                          [7.8, 0],
                          [4.7, -1.2],
                          [2.6, 0.9],
                          [0, 0],
                          [0.7, 0],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.1, -0.5],
                          [0, 0],
                          [1.141, -4.094],
                          [-0.03, -2.172],
                          [-1.331, -5.027],
                          [0.354, -1.418],
                          [0, 0],
                          [0, -0.5],
                          [-2.2, -0.2],
                          [0, 0],
                          [-0.6, 0.2],
                          [0, 0],
                          [-4.347, -1.437],
                          [-7.9, 0],
                          [-1.719, -0.06],
                          [-5.429, 2.003],
                          [-2.6, -0.8],
                          [0, 0],
                          [-0.7, 0],
                          [-0.8, 0.8],
                          [0, 1.1],
                          [0.1, 0.5],
                        ],
                        o: [
                          [-0.7, -2.9],
                          [1.326, -4.188],
                          [0.1, -3.8],
                          [-0.8, -3.6],
                          [0, 0],
                          [0.1, -0.5],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.7, 0],
                          [0, 0],
                          [-3.3, 1.2],
                          [-4.7, -1.2],
                          [-7.8, 0],
                          [-4, 0.9],
                          [0, 0],
                          [-0.6, -0.2],
                          [-2.2, -0.2],
                          [0, 0],
                          [0, 0.5],
                          [0, 0],
                          [0.7, 2.9],
                          [-1.141, 4.094],
                          [0.03, 2.172],
                          [1.331, 5.027],
                          [-0.354, 1.417],
                          [-0.1, 0.5],
                          [-0.1, 2.2],
                          [0, 0],
                          [0.7, 0],
                          [0, 0],
                          [3.3, -1.2],
                          [4.347, 1.437],
                          [0, 0],
                          [1.719, 0.06],
                          [5.429, -2.003],
                          [0, 0],
                          [0.6, 0.2],
                          [1.1, 0],
                          [0.8, -0.8],
                          [0, -0.5],
                          [0, 0],
                        ],
                        v: [
                          [43.462, 27.202],
                          [42.758, 13.59],
                          [44.586, -2.069],
                          [42.503, -18.559],
                          [45.084, -28.425],
                          [45.284, -29.425],
                          [45.484, -30.925],
                          [41.784, -35.025],
                          [41.384, -35.025],
                          [39.284, -34.625],
                          [39.184, -34.625],
                          [21.515, -31.806],
                          [-0.684, -34.134],
                          [-21.567, -31.77],
                          [-37.031, -34.342],
                          [-37.231, -34.342],
                          [-39.231, -34.642],
                          [-43.431, -30.942],
                          [-43.431, -30.542],
                          [-43.231, -29.042],
                          [-43.031, -28.042],
                          [-41.405, -13.536],
                          [-42.877, -1.37],
                          [-41.913, 12.1],
                          [-41.836, 23.833],
                          [-43.06, 27.822],
                          [-43.26, 29.322],
                          [-39.56, 33.522],
                          [-39.16, 33.522],
                          [-37.16, 33.222],
                          [-37.06, 33.222],
                          [-21.431, 31.673],
                          [1.107, 33.924],
                          [5.561, 33.833],
                          [21.41, 31.667],
                          [36.684, 33.822],
                          [36.884, 33.922],
                          [38.884, 34.222],
                          [42.762, 32.602],
                          [43.962, 29.602],
                          [43.762, 28.102],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.667,
                      y: 1,
                    },
                    o: {
                      x: 0.167,
                      y: 0,
                    },
                    n: '0p667_1_0p167_0',
                    t: 84,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [-1.326, 4.188],
                          [0.1, 3.8],
                          [0.8, 3.7],
                          [-0.7, 2.9],
                          [0, 0],
                          [0, 0.5],
                          [2.2, 0.1],
                          [0, 0],
                          [0.7, -0.3],
                          [0, 0],
                          [3.7, 0.8],
                          [7.8, 0],
                          [4.7, -1.2],
                          [2.6, 0.9],
                          [0, 0],
                          [0.7, 0],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.1, -0.5],
                          [0, 0],
                          [1.141, -4.094],
                          [-0.03, -2.172],
                          [-1.331, -5.027],
                          [0.354, -1.418],
                          [0, 0],
                          [0, -0.5],
                          [-2.2, -0.2],
                          [0, 0],
                          [-0.6, 0.2],
                          [0, 0],
                          [-4.347, -1.437],
                          [-7.9, 0],
                          [-1.719, -0.06],
                          [-5.429, 2.003],
                          [-2.6, -0.8],
                          [0, 0],
                          [-0.7, 0],
                          [-0.8, 0.8],
                          [0, 1.1],
                          [0.1, 0.5],
                        ],
                        o: [
                          [-0.7, -2.9],
                          [1.326, -4.188],
                          [0.1, -3.8],
                          [-0.8, -3.6],
                          [0, 0],
                          [0.1, -0.5],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.7, 0],
                          [0, 0],
                          [-3.3, 1.2],
                          [-4.7, -1.2],
                          [-7.8, 0],
                          [-4, 0.9],
                          [0, 0],
                          [-0.6, -0.2],
                          [-2.2, -0.2],
                          [0, 0],
                          [0, 0.5],
                          [0, 0],
                          [0.7, 2.9],
                          [-1.141, 4.094],
                          [0.03, 2.172],
                          [1.331, 5.027],
                          [-0.354, 1.417],
                          [-0.1, 0.5],
                          [-0.1, 2.2],
                          [0, 0],
                          [0.7, 0],
                          [0, 0],
                          [3.3, -1.2],
                          [4.347, 1.437],
                          [0, 0],
                          [1.719, 0.06],
                          [5.429, -2.003],
                          [0, 0],
                          [0.6, 0.2],
                          [1.1, 0],
                          [0.8, -0.8],
                          [0, -0.5],
                          [0, 0],
                        ],
                        v: [
                          [43.462, 27.202],
                          [42.758, 13.59],
                          [44.586, -2.069],
                          [42.503, -18.559],
                          [45.084, -28.425],
                          [45.284, -29.425],
                          [45.484, -30.925],
                          [41.784, -35.025],
                          [41.384, -35.025],
                          [39.284, -34.625],
                          [39.184, -34.625],
                          [21.515, -31.806],
                          [-0.684, -34.134],
                          [-21.567, -31.77],
                          [-37.031, -34.342],
                          [-37.231, -34.342],
                          [-39.231, -34.642],
                          [-43.431, -30.942],
                          [-43.431, -30.542],
                          [-43.231, -29.042],
                          [-43.031, -28.042],
                          [-41.405, -13.536],
                          [-42.877, -1.37],
                          [-41.913, 12.1],
                          [-41.836, 23.833],
                          [-43.06, 27.822],
                          [-43.26, 29.322],
                          [-39.56, 33.522],
                          [-39.16, 33.522],
                          [-37.16, 33.222],
                          [-37.06, 33.222],
                          [-21.431, 31.673],
                          [1.107, 33.924],
                          [5.561, 33.833],
                          [21.41, 31.667],
                          [36.684, 33.822],
                          [36.884, 33.922],
                          [38.884, 34.222],
                          [42.762, 32.602],
                          [43.962, 29.602],
                          [43.762, 28.102],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [0, 0],
                          [-1.326, 4.188],
                          [0.1, 3.8],
                          [0.8, 3.7],
                          [-0.7, 2.9],
                          [0, 0],
                          [0, 0.5],
                          [2.2, 0.1],
                          [0, 0],
                          [0.7, -0.3],
                          [0, 0],
                          [3.7, 0.8],
                          [7.8, 0],
                          [4.7, -1.2],
                          [2.6, 0.9],
                          [0, 0],
                          [0.7, 0],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.1, -0.5],
                          [0, 0],
                          [1.141, -4.094],
                          [-0.03, -2.172],
                          [-1.331, -5.027],
                          [0.354, -1.418],
                          [0, 0],
                          [0, -0.5],
                          [-2.2, -0.2],
                          [0, 0],
                          [-0.6, 0.2],
                          [0, 0],
                          [-4.347, -1.437],
                          [-7.9, 0],
                          [-1.719, -0.06],
                          [-5.429, 2.003],
                          [-2.6, -0.8],
                          [0, 0],
                          [-0.7, 0],
                          [-0.8, 0.8],
                          [0, 1.1],
                          [0.1, 0.5],
                        ],
                        o: [
                          [-0.7, -2.9],
                          [1.326, -4.188],
                          [0.1, -3.8],
                          [-0.8, -3.6],
                          [0, 0],
                          [0.1, -0.5],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.7, 0],
                          [0, 0],
                          [-3.3, 1.2],
                          [-4.7, -1.2],
                          [-7.8, 0],
                          [-4, 0.9],
                          [0, 0],
                          [-0.6, -0.2],
                          [-2.2, -0.2],
                          [0, 0],
                          [0, 0.5],
                          [0, 0],
                          [0.7, 2.9],
                          [-1.141, 4.094],
                          [0.03, 2.172],
                          [1.331, 5.027],
                          [-0.354, 1.417],
                          [-0.1, 0.5],
                          [-0.1, 2.2],
                          [0, 0],
                          [0.7, 0],
                          [0, 0],
                          [3.3, -1.2],
                          [4.347, 1.437],
                          [0, 0],
                          [1.719, 0.06],
                          [5.429, -2.003],
                          [0, 0],
                          [0.6, 0.2],
                          [1.1, 0],
                          [0.8, -0.8],
                          [0, -0.5],
                          [0, 0],
                        ],
                        v: [
                          [43.462, 27.202],
                          [42.758, 13.59],
                          [44.586, -2.069],
                          [42.503, -18.559],
                          [45.084, -28.425],
                          [45.284, -29.425],
                          [45.484, -30.925],
                          [41.784, -35.025],
                          [41.384, -35.025],
                          [39.284, -34.625],
                          [39.184, -34.625],
                          [21.515, -31.806],
                          [-0.684, -34.134],
                          [-21.567, -31.77],
                          [-37.031, -34.342],
                          [-37.231, -34.342],
                          [-39.231, -34.642],
                          [-43.431, -30.942],
                          [-43.431, -30.542],
                          [-43.231, -29.042],
                          [-43.031, -28.042],
                          [-41.405, -13.536],
                          [-42.877, -1.37],
                          [-41.913, 12.1],
                          [-41.836, 23.833],
                          [-43.06, 27.822],
                          [-43.26, 29.322],
                          [-39.56, 33.522],
                          [-39.16, 33.522],
                          [-37.16, 33.222],
                          [-37.06, 33.222],
                          [-21.431, 31.673],
                          [1.107, 33.924],
                          [5.561, 33.833],
                          [21.41, 31.667],
                          [36.684, 33.822],
                          [36.884, 33.922],
                          [38.884, 34.222],
                          [42.762, 32.602],
                          [43.962, 29.602],
                          [43.762, 28.102],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 1,
                      y: 1,
                    },
                    o: {
                      x: 0.167,
                      y: 0,
                    },
                    n: '1_1_0p167_0',
                    t: 118,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [-1.326, 4.188],
                          [0.1, 3.8],
                          [0.8, 3.7],
                          [-0.7, 2.9],
                          [0, 0],
                          [0, 0.5],
                          [2.2, 0.1],
                          [0, 0],
                          [0.7, -0.3],
                          [0, 0],
                          [3.7, 0.8],
                          [7.8, 0],
                          [4.7, -1.2],
                          [2.6, 0.9],
                          [0, 0],
                          [0.7, 0],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.1, -0.5],
                          [0, 0],
                          [1.141, -4.094],
                          [-0.03, -2.172],
                          [-1.331, -5.027],
                          [0.354, -1.418],
                          [0, 0],
                          [0, -0.5],
                          [-2.2, -0.2],
                          [0, 0],
                          [-0.6, 0.2],
                          [0, 0],
                          [-4.347, -1.437],
                          [-7.9, 0],
                          [-1.719, -0.06],
                          [-5.429, 2.003],
                          [-2.6, -0.8],
                          [0, 0],
                          [-0.7, 0],
                          [-0.8, 0.8],
                          [0, 1.1],
                          [0.1, 0.5],
                        ],
                        o: [
                          [-0.7, -2.9],
                          [1.326, -4.188],
                          [0.1, -3.8],
                          [-0.8, -3.6],
                          [0, 0],
                          [0.1, -0.5],
                          [0.1, -2.2],
                          [0, 0],
                          [-0.7, 0],
                          [0, 0],
                          [-3.3, 1.2],
                          [-4.7, -1.2],
                          [-7.8, 0],
                          [-4, 0.9],
                          [0, 0],
                          [-0.6, -0.2],
                          [-2.2, -0.2],
                          [0, 0],
                          [0, 0.5],
                          [0, 0],
                          [0.7, 2.9],
                          [-1.141, 4.094],
                          [0.03, 2.172],
                          [1.331, 5.027],
                          [-0.354, 1.417],
                          [-0.1, 0.5],
                          [-0.1, 2.2],
                          [0, 0],
                          [0.7, 0],
                          [0, 0],
                          [3.3, -1.2],
                          [4.347, 1.437],
                          [0, 0],
                          [1.719, 0.06],
                          [5.429, -2.003],
                          [0, 0],
                          [0.6, 0.2],
                          [1.1, 0],
                          [0.8, -0.8],
                          [0, -0.5],
                          [0, 0],
                        ],
                        v: [
                          [43.462, 27.202],
                          [42.758, 13.59],
                          [44.586, -2.069],
                          [42.503, -18.559],
                          [45.084, -28.425],
                          [45.284, -29.425],
                          [45.484, -30.925],
                          [41.784, -35.025],
                          [41.384, -35.025],
                          [39.284, -34.625],
                          [39.184, -34.625],
                          [21.515, -31.806],
                          [-0.684, -34.134],
                          [-21.567, -31.77],
                          [-37.031, -34.342],
                          [-37.231, -34.342],
                          [-39.231, -34.642],
                          [-43.431, -30.942],
                          [-43.431, -30.542],
                          [-43.231, -29.042],
                          [-43.031, -28.042],
                          [-41.405, -13.536],
                          [-42.877, -1.37],
                          [-41.913, 12.1],
                          [-41.836, 23.833],
                          [-43.06, 27.822],
                          [-43.26, 29.322],
                          [-39.56, 33.522],
                          [-39.16, 33.522],
                          [-37.16, 33.222],
                          [-37.06, 33.222],
                          [-21.431, 31.673],
                          [1.107, 33.924],
                          [5.561, 33.833],
                          [21.41, 31.667],
                          [36.684, 33.822],
                          [36.884, 33.922],
                          [38.884, 34.222],
                          [42.762, 32.602],
                          [43.962, 29.602],
                          [43.762, 28.102],
                        ],
                        c: true,
                      },
                    ],
                    e: [
                      {
                        i: [
                          [-0.008, 0.651],
                          [0.234, 0.749],
                          [0.254, 0.681],
                          [0.457, 0.684],
                          [0.442, 0.655],
                          [0.64, 0.537],
                          [0.743, 0.623],
                          [1.086, 0.604],
                          [0.69, 0.301],
                          [0.868, 0.214],
                          [0.742, 0.122],
                          [0.73, -0.108],
                          [0.614, -0.17],
                          [0.545, -0.191],
                          [0.421, -0.222],
                          [0.609, -0.354],
                          [0.408, -0.33],
                          [0.437, -0.522],
                          [0.373, -0.724],
                          [0.201, -0.699],
                          [0.207, -0.72],
                          [0.075, -1.008],
                          [-0.055, -1.134],
                          [-0.167, -0.73],
                          [-0.206, -0.737],
                          [-0.527, -1.239],
                          [-0.682, -1.157],
                          [-0.744, -0.954],
                          [-0.769, -0.83],
                          [-0.729, -0.52],
                          [-1, -0.67],
                          [-1.122, -0.478],
                          [-0.82, -0.238],
                          [-0.475, -0.043],
                          [-0.521, 0.125],
                          [-0.941, 0.583],
                          [-0.485, 0.389],
                          [-0.481, 0.624],
                          [-0.23, 0.404],
                          [-0.205, 0.473],
                          [-0.089, 0.606],
                        ],
                        o: [
                          [0.008, -0.651],
                          [-0.234, -0.749],
                          [-0.254, -0.681],
                          [-0.457, -0.684],
                          [-0.442, -0.655],
                          [-0.64, -0.537],
                          [-0.743, -0.623],
                          [-1.086, -0.604],
                          [-0.69, -0.302],
                          [-0.868, -0.214],
                          [-0.742, -0.122],
                          [-0.73, 0.108],
                          [-0.614, 0.17],
                          [-0.545, 0.191],
                          [-0.421, 0.222],
                          [-0.609, 0.354],
                          [-0.408, 0.33],
                          [-0.437, 0.522],
                          [-0.373, 0.724],
                          [-0.201, 0.699],
                          [-0.207, 0.72],
                          [-0.075, 1.008],
                          [0.055, 1.134],
                          [0.167, 0.73],
                          [0.207, 0.737],
                          [0.525, 1.236],
                          [0.615, 1.042],
                          [0.696, 0.892],
                          [0.65, 0.701],
                          [0.729, 0.52],
                          [1.403, 0.94],
                          [1.122, 0.478],
                          [0.82, 0.238],
                          [0.475, 0.043],
                          [0.521, -0.125],
                          [0.941, -0.583],
                          [0.485, -0.389],
                          [0.481, -0.624],
                          [0.23, -0.404],
                          [0.205, -0.473],
                          [0.089, -0.606],
                        ],
                        v: [
                          [21.064, -0.892],
                          [20.746, -4.293],
                          [19.822, -7.447],
                          [18.61, -10.518],
                          [16.656, -13.26],
                          [14.849, -15.522],
                          [12.485, -17.553],
                          [9.765, -19.13],
                          [7.083, -20.109],
                          [4.596, -20.818],
                          [1.778, -21.117],
                          [-1.539, -21.233],
                          [-4.808, -20.598],
                          [-7.898, -19.428],
                          [-10.16, -18.231],
                          [-12.558, -16.512],
                          [-14.071, -15.455],
                          [-15.643, -13.642],
                          [-17.217, -11.587],
                          [-18.587, -8.853],
                          [-19.62, -5.816],
                          [-20.272, -2.506],
                          [-20.273, 0.183],
                          [-20.039, 3.294],
                          [-19.4, 5.596],
                          [-18.778, 7.485],
                          [-17.602, 9.434],
                          [-16.412, 11.268],
                          [-14.553, 13.496],
                          [-11.753, 16.083],
                          [-8.758, 17.736],
                          [-5.919, 18.929],
                          [-3.513, 19.607],
                          [-0.622, 19.902],
                          [4.054, 19.77],
                          [9.046, 18.115],
                          [13.265, 15.507],
                          [16.455, 12.555],
                          [18.616, 9.175],
                          [19.961, 6.41],
                          [20.755, 2.961],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 135.000005498663,
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.642999985639, 0.642999985639, 0.642999985639, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [36.7, 28.7],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [94.407, 94.407],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 142.000005783779,
      st: -271.000011038056,
      bm: 0,
    },
  ],
  markers: [],
};
